import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import TypeSelectorWindowViewModelType from '@/ViewModels/Controls/TypeSelectorWindowViewModel';
import WindowType from '@/Controls/Window';
import DropDownListType from '@/Controls/DropDownList';
import ButtonType from '@/Controls/Button';

export default class TypeSelectorWindow extends Control {

    private Window = ComponentManager.getControl<typeof WindowType>('Window');
    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    private Button = ComponentManager.getControl<typeof ButtonType>('Button');
    private jQueryControl: JQuery;
    private dropDownList: DropDownListType;
    private elements: Array<ButtonType>;

    public constructor(private viewModel: TypeSelectorWindowViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'typeselectorwindow',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        let window = new this.Window(this.viewModel.window);
        let tuple = window.getTuple();
        tuple.control.appendTo(this.jQueryControl);

        this.defineComputed(() => {
            let content = this.viewModel.window.content();

            if (content.length > 0) {
                let body = $('<div class="body">').appendTo(content);
                let footer = $('<div class="footer"><button></div>').appendTo(content);

                this.applyBindings(body, {
                    controlName: 'typeselectorwindow',

                    controlIdent: this.identifier
                });

                this.dropDownList = new this.DropDownList(this.viewModel.dropDownList);
                let tuple = this.dropDownList.getTuple();
                tuple.control.appendTo(body);

                this.elements = [];

                this.applyBindings(footer, {
                    foreach: {
                        data: this.viewModel.buttons,

                        afterRender: (elements, buttonViewModel) => {
                            for (let i = 0; i < elements.length; i++) {
                                let button = new this.Button(buttonViewModel, $(elements[i]));
                                let tuple = button.getTuple();

                                this.elements.push(button);
                            }
                        }
                    }
                });
            }
        });
    }
}

ComponentManager.setControl('TypeSelectorWindow', TypeSelectorWindow, 'RADPresentation.HTMLClient.DefaultViewExtensions');